<div class="table-responsive" *ngIf="urunGruplar">
  <table class="table card-table table-vcenter text-nowrap datatable">
    <thead>
    <tr>
      <th class="w-1">Id</th>
      <th>İsim</th>
      <th>Tahmini Teslim Gün Sayısı</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let k of urunGruplar">
      <td><span class="text-muted">{{k.id}}</span></td>
      <td>{{k.isim}}</td>
      <td>{{k.tahminiTeslimGun}} Gün</td>
      <td class="text-right">
        <div class="btn btn-sm btn-success" (click)="incele(k)">İncele</div>
        <div class="btn btn-sm btn-danger ml-3" (click)="kaldir(k)">Kaldır</div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
